import {
  deDE as deDECore,
  enUS as enUSCore,
  esES as esESCore,
  frFR as frFRCore,
  itIT as itITCore,
} from '@mui/material/locale';
import {
  deDE as deDEDataGrid,
  enUS as enUSDataGrid,
  esES as esESDataGrid,
  frFR as frFRDataGrid,
  itIT as itITDataGrid,
} from '@mui/x-data-grid-premium/locales';
import {
  deDE as deDEDate,
  enUS as enUSDate,
  esES as esESDate,
  frFR as frFRDate,
  itIT as itITDate,
} from '@mui/x-date-pickers/locales';

import { de as deDEAdapter } from 'date-fns/locale/de';
import { enUS as enUSAdapter } from 'date-fns/locale/en-US';
import { es as esESAdapter } from 'date-fns/locale/es';
import { fr as frFRAdapter } from 'date-fns/locale/fr';
import { it as itITAdapter } from 'date-fns/locale/it';

// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Français',
    value: 'fr',
    adapterLocale: frFRAdapter,
    icon: 'fr',
    muiStrings: {
      core: frFRCore,
      grid: frFRDataGrid,
      date: frFRDate,
    },
  },
  {
    label: 'English',
    value: 'en',
    adapterLocale: enUSAdapter,
    icon: 'us',
    muiStrings: {
      core: enUSCore,
      grid: enUSDataGrid,
      date: enUSDate,
    },
  },
  {
    label: 'Español',
    value: 'es',
    adapterLocale: esESAdapter,
    icon: 'es',
    muiStrings: {
      core: esESCore,
      grid: esESDataGrid,
      date: esESDate,
    },
  },
  {
    label: 'Italiano',
    value: 'it',
    adapterLocale: itITAdapter,
    icon: 'it',
    muiStrings: {
      core: itITCore,
      grid: itITDataGrid,
      date: itITDate,
    },
  },
  {
    label: 'Deutsch',
    value: 'de',
    adapterLocale: deDEAdapter,
    icon: 'de',
    muiStrings: {
      core: deDECore,
      grid: deDEDataGrid,
      date: deDEDate,
    },
  },
];

export const defaultLang = allLangs[1]; // English
